<template>
    <div
        class="redesign-input__label"
        data-testid="form-label"
        :class="{ 'min-h-5': label || icon }"
    >
        <div class="redesign-input__label-wrapper flex items-center main-text-color" data-testid="form-label-wrapper">
            <span
                v-if="icon"
                class="redesign-input__label-wrapper--left-item"
            >
                <redesign-base-icon
                    :name="icon"
                    :size="16"
                    class="icon-lg redesign-input__label-wrapper--left-item-icon"
                />
            </span>
            <span
                v-if="label"
                class="redesign-input__label-wrapper-label"
                data-testid="form-label-text"
            >
                {{ label }}
                <span
                    v-if="required"
                    class="redesign-input__label-wrapper-label__required-icon"
                    data-testid="form-label-required"
                >
                    *
                </span>
            </span>
            <VcPopover
                v-if="infoText || $slots['info-text']"
                trigger="hover"
                :popover-width="infoTooltipWidth"
                placement="top"
            >
                <template #reference>
                    <span class="redesign-input__label-info px-1 flex items-center">
                        <i class="vc-icon-info icon-base" />
                    </span>
                </template>
                <div
                    class="label-info-text break-normal p-2 text-xs"
                >
                    <slot name="info-text">
                        {{ infoText }}
                    </slot>
                </div>
            </VcPopover>
        </div>
        <span
            v-if="$slots['label-action']"
            class="redesign-input__label-actions"
        >
            <slot name="label-action" />
        </span>
    </div>
</template>

<script setup lang="ts">
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'
import { TranslateResult } from 'vue-i18n'
import { VcPopover } from '@voicenter-team/voicenter-ui-plus'

interface IUseInputLabelProps {
    required?: boolean
    label?: string | TranslateResult
    icon?: string
    infoText?: string | TranslateResult
    infoTooltipWidth?: string | number
}

withDefaults(defineProps<IUseInputLabelProps>(), {
    required: false,
    label: '',
    icon: '',
    infoText: '',
    infoTooltipWidth: 180
})

</script>

<style lang="scss">
.redesign-input__label {
    @apply flex w-full leading-none items-center;
    color: var(--mainTextColor-color);
    &-wrapper {
        @apply flex text-sm font-normal flex-grow gap-2;
        &--left-item {
            @apply inline-flex;
            &-icon {
                @apply leading-none text-icons;
            }
        }
        &-label {
            @apply text-sm font-normal;
            &__required-icon {
                @apply text-primary-actions;
            }
        }
    }
    &-info {
        @apply text-active-elements cursor-pointer;
    }
    &-actions {
        @apply ml-2 rtl:mr-2 rtl:ml-0;
    }
}
</style>
